/// <amd-module name="Wiki/WitQuery/WitConstants" />
export const enum ColumnWidth {
    DefaultMinWidth = 120,
    DefaultMaxWidth = 440
}

export const enum WitQueryTableConstants {
    MaxNumberOfWorkItems = 200
}

export const enum WitQueryErrorTypes {
    OnlySharedQuerySupported = "OnlySharedQuerySupported",
    QueryNotFound = "QueryNotFound",
    EmptyQueryId = "EmptyQueryId",
    UnknownError = "UnknownError"
}

export const enum TelemetryConstants {
    Area = "Wiki",
    WitQueryAttachWitCount = "WitQueryAttachWitCount",
    WitQueryAttachFailed = "WitQueryAttachFailed",
    WitQueryAttachViewQueryClicked = "WitQueryAttachViewQueryClicked"
}
